__turbopack_context__.v({
  "action": "OcrFrame-module__tavOGG__action",
  "active": "OcrFrame-module__tavOGG__active",
  "android": "OcrFrame-module__tavOGG__android",
  "camera": "OcrFrame-module__tavOGG__camera",
  "canvas-container": "OcrFrame-module__tavOGG__canvas-container",
  "close_button": "OcrFrame-module__tavOGG__close_button",
  "controls": "OcrFrame-module__tavOGG__controls",
  "frame": "OcrFrame-module__tavOGG__frame",
  "frame-container": "OcrFrame-module__tavOGG__frame-container",
  "frame_ios": "OcrFrame-module__tavOGG__frame_ios",
  "image_canvas": "OcrFrame-module__tavOGG__image_canvas",
  "is-video": "OcrFrame-module__tavOGG__is-video",
  "main-container": "OcrFrame-module__tavOGG__main-container",
  "media": "OcrFrame-module__tavOGG__media",
  "media-type": "OcrFrame-module__tavOGG__media-type",
  "modal-body": "OcrFrame-module__tavOGG__modal-body",
  "movable": "OcrFrame-module__tavOGG__movable",
  "reset": "OcrFrame-module__tavOGG__reset",
  "shutter": "OcrFrame-module__tavOGG__shutter",
  "shutter-container": "OcrFrame-module__tavOGG__shutter-container",
  "swap-camera": "OcrFrame-module__tavOGG__swap-camera",
  "video": "OcrFrame-module__tavOGG__video",
  "video_canvas": "OcrFrame-module__tavOGG__video_canvas",
});
